import React,{useEffect} from "react";

import GoBackHeaderMobile from "../../Mobile/GoBackHeaderMobile/GoBackHeaderMobile";
import DepartmentsMobile from "../../Mobile/DepartmentsMobile/DepartmentsMobile";
import ClinicsListMobile from "../../Mobile/ClinicsListMobile/ClinicsListMobile";
import FooterMobile from "../../../components/Mobile/FooterMobile/FooterMobile";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/all";

const ClinicsMobile = (props) => {
  gsap.registerPlugin(ScrollTrigger)
  useEffect(()=>{
    window.scrollTo({ top: 0})
  },[])

  return (
    <>
      <GoBackHeaderMobile />
      <DepartmentsMobile small={true} />
      <ClinicsListMobile />
      <FooterMobile enableScroll={false}/>
      <div id="portal"></div>
    </>
  );
};
export default ClinicsMobile;
